<h3 class="card-title">{{ 'label.dates' | translate }}</h3>
<div class="wrapper">
  @if (hasAgreementDataToDisplay$ | async) {
    <div class="start-date property" *ngIf="hasAgreementDataToDisplay$ | async">
      <div class="title">{{ 'label.startDate' | translate }}</div>
      <span class="status">{{ startTimestamp$ | async | formatDateTime }}</span>
    </div>
    @if (agreement) {
      <ax-agreement-verification-status
        *ngIf="proposalHasVerification"
        [agreement]="agreement"
        [verification]="proposal?.verification"
      ></ax-agreement-verification-status>
    }

    <div
      class="end-date property"
      *ngIf="agreement?.expirationTimestamp || (agreementData?.endTimestamp && isHistoryAgreement$)"
    >
      <div class="title">{{ 'label.endDate' | translate }}</div>
      {{ agreementData?.endTimestamp || agreement?.expirationTimestamp | formatDateTime }}
    </div>
    <div class="property" *ngIf="agreement?.active && (isSubscriber$ | async) === false">
      <div class="title">{{ 'label.modifiedDate' | translate }}</div>
      <span *ngIf="agreement?.modificationTimestamp as modifiedDate">
        {{ modifiedDate | formatDateTime }}
      </span>
    </div>
    <div class="property">
      <div class="title">
        {{
          ((isSubscriber$ | async) ? 'label.modifiedDate' : 'label.dataModifiedDate') | translate
        }}
      </div>
      <span *ngIf="agreement?.agreementData?.startTimestamp as startTimestamp">
        {{ startTimestamp | formatDateTime }}
      </span>

      @if (agreementData?.creatorId && (agreementCreator$ | async)) {
        <span> ({{ agreementCreator$ | async | displayName }}) </span>
      } @else if ((createdBySubject$ | async) !== '') {
        <span>
          ({{
            'label.modified.by'
              | translate: {subject: createdBySubject$ | async | translate | lowercase}
          }})
        </span>
      }
    </div>

    @if (!agreement?.active) {
      <div class="property">
        <div class="title">{{ 'label.expiredDate' | translate }}</div>
        <span>
          {{ agreement?.expirationTimestamp | formatDateTime }}
        </span>
      </div>
    }
  }
  @if (agreement?.deletedByOwner) {
    <div class="property">
      <div class="title">{{ 'label.deletedDate' | translate }}</div>
      <span>
        {{ agreement?.deletedByOwnerTimestamp | formatDateTime }}
      </span>
    </div>
  }
</div>
